/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import UpdateableComponentBase from './UpdateableComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Implementation of [[UpdateableComponentBase]] for hiding or showing a [[cc.Node]] based on the target observable.
 */
@cc._decorator.ccclass
export default class UpdateableColorComponent extends UpdateableComponentBase<any, cc.Color>
{
    protected component: cc.Node = this.node;

    /** @hidden */
    protected updateUI = (event?: cc.Event.EventCustom): void =>
    {
        if (!this.observable) { return; }
        if (!this.component) { this.component = this.node; }

        this.component.color = this.observable.Value;
    }
}
